var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMaintenance = function SvgMaintenance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2414 1H14.7586L13.6897 3.67241L9.41379 5.81035L7.27586 5.27586L3 12.2241L4.60345 14.3621V18.6379L3 20.7759L7.27586 27.7241L9.94828 27.1897L13.6897 29.3276L14.7586 32H22.2414L23.3103 29.3276L27.0517 27.1897L29.7241 27.7241L33.4655 20.7759L31.8621 18.6379V14.8966L33.4655 12.2241L29.7241 5.27586L27.0517 5.81035L23.3103 3.67241L22.2414 1ZM28 16.5C28 21.7467 23.7467 26 18.5 26C13.2533 26 9 21.7467 9 16.5C9 11.2533 13.2533 7 18.5 7C23.7467 7 28 11.2533 28 16.5ZM13 14.8142C13 12.7329 14.3974 10.9485 16.3855 10.1948C16.6909 10.079 17 10.3182 17 10.6449V14.8142L18.1636 15.8725C18.3543 16.046 18.6457 16.046 18.8364 15.8725L20 14.8142V10.6449C20 10.3182 20.3091 10.079 20.6145 10.1948C22.6026 10.9485 24 12.7329 24 14.8142C24 16.7582 22.7808 18.4432 21 19.2712V22.5452C21 22.5452 20 23 18.5 23C17 23 16 22.5452 16 22.5452V19.2712C14.2192 18.4432 13 16.7582 13 14.8142Z",
    fill: "#0073BF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaintenance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maintenance.eb3f615a.svg";
export { ForwardRef as ReactComponent };